module.exports = __webpack_public_path__ + "static/media/29FUNOV11.24f492de.jpg";